import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { filter, withLatestFrom, concatMap } from 'rxjs/operators';
import { Action } from 'redux';
import { UpdateCollaboratorField, UpdateCollaborator } from '../action-creators';
import { UPDATE_COLLABORATOR_FIELD } from '../actions';
import AppState from '../../state';
import { keyDebounceTime } from '../../operators';


export const autosaveEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action, UpdateCollaboratorField<any>>(UPDATE_COLLABORATOR_FIELD),
    keyDebounceTime(2000, (action) => `${action.assetId}-${action.collaboratorId}`),
    withLatestFrom(state$),
    filter(([_, state]) => state.collaborator.updateStatus === 'modified'),
    concatMap(([actions, state]) => {
      return actions
        .filter((action) => {
          return action.assetId in state.collaborator.assets &&
                 action.collaboratorId in state.collaborator.assets[action.assetId];
        })
        .map((action) => new UpdateCollaborator(state.collaborator.assets[action.assetId][action.collaboratorId]))
    })
  );